import $ from 'jquery';

$( function() {
	$( document ).ready( function() {
		if ( $( '.wp-block-prj-pt-gutenberg-blocks-newsletter.nl-69' )[ 0 ] ) {
			$( '.wp-block-prj-pt-gutenberg-blocks-newsletter.nl-69' ).find( '#nl-field-0' ).attr( 'type', 'email' );
		}
	} );
	$( '.wp-block-prj-pt-gutenberg-blocks-newsletter form [type="submit"]' ).on( 'click keydown', function( e ) {
		if ( 'keydown' === e.type && ( e.which !== 13 || e.which !== 32 ) ) {
			return;
		}
		const $form = $( this ).closest( 'form' );
		$form.find( 'label' ).removeClass( 'invalid' );
		$form.find( 'input' ).each( function() {
			$( this ).addClass( 'submitted' );
			const isValid = this.checkValidity();
			if ( ! isValid ) {
				$( 'label[for="' + this.id + '"]' ).addClass( 'invalid' );
				$( '#error-for-' + this.id ).addClass( 'show' );
			}
		} );
	} );

	$( '.wp-block-prj-pt-gutenberg-blocks-newsletter form' ).on( 'input', '.submitted', function() {
		const isValid = this.checkValidity();
		const $label = $( 'label[for="' + this.id + '"]' );
		const $errorDiv = $( '#error-for-' + this.id );
		if ( isValid ) {
			$label.removeClass( 'invalid' );
			$errorDiv.removeClass( 'show' );
			$( this ).removeClass( 'submitted' );
		} else {
			$label.addClass( 'invalid' );
			$errorDiv.addClass( 'show' );
		}
	} );

	$( '.wp-block-prj-pt-gutenberg-blocks-newsletter form' ).on( 'submit', function( e ) {
		e.preventDefault();
		const $form = $( this );
		$.ajax(
			$form.data( 'endpoint' ),
			{
				method: 'POST',
				data: JSON.stringify( $form.serializeArray() ),
				beforeSend: function() {
					$form.parent().find( '.loading-wrap' ).addClass( 'loading' );
				},
				success: function( data ) {
					$form.hide();
					if ( 'true' === data ) {
						$form.parent().find( '.success-text' ).show();
					} else {
						if ( $form.attr( 'action' ) === 'https://secure.pt-dlr.de/pt-newsletter/Newsletter/deregistration/69' ) {
							$form.show();
						}
						$form.parent().find( '.error-text' ).show();
					}
				},
				error: function( ) {
					$form.hide();
					$form.parent().find( '.error-text' ).show();
				},
				complete: function() {
					$form.parent().find( '.loading-wrap' ).removeClass( 'loading' );
				},
			}
		);
	} );
} );
